import React, { ReactElement } from "react";
import styles from "./AccountCard.module.scss";
import { formatCurrency } from "@tiicker/util/lib/formats";
import { brokerDetailMapping } from "components/BrokerConnectionMessage/BrokerConnectionMessage";
import classNames from "classnames";

interface Props {
  isActive: boolean;

  brokerName: string;
  brokerLogo?: string;
  buyingPower: number;
  accountName: string;
  accountMask: string;

  tickerSymbol: string;
  shareCount: number;
  shareValue: number;
  onClick?(brokerName: string): void;
}

export default function AccountCard(props: Props): ReactElement {
  const logoUrl =
    props.brokerLogo || brokerDetailMapping[props.brokerName]?.logoUrl;

  return (
    <>
      <div
        onClick={() => props.onClick && props.onClick(props.brokerName)}
        data-cy="account-card"
        className={classNames(
          styles.card,
          props.isActive ? "" : "cardInactive"
        )}
      >
        <div className={styles.logoWrapper}>
          {logoUrl ? (
            <img
              className={classNames(styles.brokerLogo, "lazyload")}
              data-src={logoUrl}
              alt={`${props.brokerName} Logo`}
            />
          ) : (
            <p className={styles.brokerName}>{props.brokerName}</p>
          )}
        </div>

        <div>
          <p className={styles.buyingPower}>
            {formatCurrency(props.buyingPower)}
          </p>
          <p className={styles.buyingPowerSubText}>Buying Power</p>
        </div>

        <div>
          <p className={styles.sectionHeading}>Account</p>
          <p className={styles.sectionContent}>{props.accountName}</p>
        </div>

        <div>
          <p className={styles.sectionContent}>• • • • {props.accountMask}</p>
        </div>

        <div>
          <p className={styles.sectionHeading}>{props.tickerSymbol} Equity</p>
          <p className={styles.sectionContent}>
            {props.shareCount} Share{props.shareCount !== 1 ? "s" : ""}
          </p>
        </div>

        <div>
          <p className={styles.sectionContent}>
            {formatCurrency(props.shareValue)}
          </p>
        </div>
      </div>
      {!props.isActive && (
        <p className={styles.disabledMessage}>
          TiiCKER does not support trading on this account
        </p>
      )}
    </>
  );
}
